import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as clientActions from 'redux/modules/clients';

var _ = require('underscore');

import { Col, Row, Alert } from 'react-bootstrap';


import { bindActionCreators } from 'redux';


import { translate } from 'react-i18next';

@translate(['common'])
@connect(
  state => ({
    checkTokenErrorMsg: state.clients.checkTokenErrorMsg,
    checkTokenSuccessMsg: state.clients.checkTokenSuccessMsg,
    checkTokenSuccess: state.clients.checkTokenSuccess,
    checkTokenError: state.clients.checkTokenError,
  }),
  dispatch => bindActionCreators(clientActions, dispatch)
)

export default class ValidateClientView extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {

    if (this.props.params.token) {
      this.props.checkValidationToken(this.props.params.token).then((message) => {

      }).catch((message) => {


      })
    }


  }


  render() {

    return (
      <div className='container'>
        <h1>Validation</h1>

        <Row>
          <Col md={5} xs={12}>

            {this.props.checkTokenSuccess &&
              <Alert bsStyle='success'>{this.props.checkTokenSuccessMsg}</Alert>
            }

            {this.props.checkTokenError &&
              <Alert bsStyle='danger'>{this.props.checkTokenErrorMsg}</Alert>
            }

          </Col>
        </Row>


      </div>
    );
  }
}

